import { INVITE_MODE, UNJOINED_MEMBER_STATUSES } from '../constants/inviteModes.js';
import { ROW_STATUS } from '../constants/reviewFilters.js';

const shouldInvite = (row, { mode, selectedIds }) => {
  if (mode === INVITE_MODE.ALL) return true;
  if (mode === INVITE_MODE.WITH_ACCESS) return row.access !== null;
  if (mode === INVITE_MODE.SELECTED) return selectedIds.includes(row.rowNumber);
  return false;
};

/**
 * Request body (snake_case) of `submitImport` built from the wizard state. Rows with errors
 * are never sent; existing members only get their profile updated.
 *
 * @param {object} state Wizard state.
 * @param {Date} [now]
 */
export function buildSubmitPayload(state, now = new Date()) {
  const { rows, invite, catalog, file } = state;
  const updateRows = rows.filter((row) => row.status === ROW_STATUS.UPDATE);
  const note = invite.note?.trim();
  return {
    file_name: file.name,
    import_date: now.toISOString().slice(0, 10),
    ...(note ? { note } : {}),
    new_members: rows
      .filter((row) => row.status === ROW_STATUS.NEW)
      .map((row) => ({
        row_number: row.rowNumber,
        email: row.person.email,
        first_name: row.person.first_name,
        last_name: row.person.last_name,
        job_title: row.person.job_title,
        user_type: row.access?.user_type ?? 'member',
        role_ids: row.access?.role_ids ?? [],
        group_ids: row.access?.group_ids ?? [],
        invite: shouldInvite(row, invite),
      })),
    updates: updateRows.map((row) => ({
      member_id: row.existingMemberId,
      first_name: row.person.first_name,
      last_name: row.person.last_name,
      job_title: row.person.job_title,
    })),
    reinvite_member_ids: invite.reinviteExisting
      ? updateRows
          .map((row) => row.existingMemberId)
          .filter((id) => UNJOINED_MEMBER_STATUSES.includes(catalog.members.find((m) => m.id === id)?.status))
      : [],
  };
}
